export default {
  props: {
    id: String,
    value: null,
    val: null,
    model: String,
    name: String,
    checked: {
      type: Boolean,
      defailt: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    inputChange: function inputChange(t, value) {
      this.$emit('input', value);
    }
  },
  computed: {}
};